import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import OffshoreMedicine from "./pages/OffshoreMedicine/OffshoreMedicine";
import DivingMedicine from "./pages/DivingMedicine/DivingMedicine";
import MaritimeMedicine from "./pages/MaritimeMedicine/MaritimeMedicine";
import OccupationalHealth from "./pages/OccupationalHealth/OccupationalHealth";
import HealthSurveillance from "./pages/HealthSurveillance/HealthSurveillance";
import OnsiteAssessment from "./pages/OnsiteAssessment/OnsiteAssessment";
import Hbot from "./pages/Hbot/Hbot";
import TrainingCenter from "./pages/TrainingCenter/TrainingCenter";
import Application from "./pages/Application";
import CertificateAuth from "./pages/CertificateAuth";
import DynamicPage from "./pages/DynamicPage";
import NotFound from "./pages/NotFound";
import NewsDetails from "./pages/NewsDetails";
import NewsPage from "./pages/NewsPage";
import PartnersPage from "./pages/PartnersPage";
import AboutPage from "./pages/AboutPage";
import FitnessForWorkAssessment from "./pages/Certificates/FitnessForWorkAssessment";
import SeafarerMedical from "./pages/Certificates/SeafarerMedical";
import ShoulderMeasurement from "./pages/Certificates/ShoulderMeasurement";
import RopeAccess from "./pages/Certificates/RopeAccess";
import IMCA from "./pages/Certificates/IMCA";
import OGUK from "./pages/Certificates/OGUK";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/offshore-medicine" element={<OffshoreMedicine />} />
        <Route path="/diving-medicine" element={<DivingMedicine />} />
        <Route path="/maritime-medicine" element={<MaritimeMedicine />} />
        <Route path="/occupational-health" element={<OccupationalHealth />} />
        <Route path="/health-surveillance" element={<HealthSurveillance />} />
        <Route path="/onsite-assessment" element={<OnsiteAssessment />} />
        <Route path="/hbot" element={<Hbot />} />
        <Route path="/training-center" element={<TrainingCenter />} />
        <Route path="/applications/add" element={<Application />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/about" element={<AboutPage />} />

        <Route path="/fitness-for-work-assessment" element={<FitnessForWorkAssessment />} />
        <Route path="/seafarer-medical-fitness-assessment" element={<SeafarerMedical />} />
        <Route path="/shoulder-measurement" element={<ShoulderMeasurement />} />
        <Route path="/rope-access-or-irata" element={<RopeAccess />} />
        <Route path="/imca-diving-certificates" element={<IMCA />} />
        <Route path="/oguk-certificate" element={<OGUK />} />

        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:slug" element={<NewsDetails />} />
        <Route
          path="/certificate-authentication"
          element={<CertificateAuth />}
        />
        <Route path="/patients/search/:dobParam/:expiryDateParam/:id" element={<CertificateAuth />} />
        <Route path="/patients/search/:dobParam/:expiryDateParam" element={<CertificateAuth />} />
        <Route path="/patients/search/:dobParam" element={<CertificateAuth />} />
        <Route path="/patients/search///:id" element={<CertificateAuth />} />

        <Route path="/page/:slug" element={<DynamicPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
